import React from 'react';
import './Hero.css';

const Hero = () => {
  // const heroStyle = {
  //   backgroundImage: `url(${process.env.PUBLIC_URL}/images/image.png)`,
  //   backgroundSize: 'cover',
  //   backgroundPosition: 'center',
  //   backgroundRepeat: 'no-repeat',
  // };

  const heroStyle = {
    backgroundImage: `linear-gradient(rgba(0,0,0,0.6), rgba(0,0,0,0.6)), url(${process.env.PUBLIC_URL}/images/image.png)`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
  };
  
  return (
    <section className="hero" style={heroStyle}>
      <div className="hero-content">
        {/* <div className="hero-logo">GARNET</div> */}
        <h1 className="hero-title">Welcome to Chalcedony Estate, Umuahia</h1>
        <p className="hero-subtitle">
          Premium Real Estate Developments in Abia State
        </p>
        <p className="hero-description">
          Discover luxury living and smart investment opportunities with Chalcedony Estate. 
          We offer thoughtfully designed plots with modern infrastructure, flexible payment plans, 
          and amenities tailored for long-term value.
        </p>
      </div>
    </section>
  );
};

export default Hero;

